import React from 'react';
import PropTypes from 'prop-types';
import ImageModal from '../../modalWindows/imageModal';
import flh from '../../../helpers/file.helper';

const AttachedFile = ({
  file,
  file: { type, id, original, uploadingPc, message },
  onRemove,
  upload,
  filenameLen = 28,
  activeModal,
  toggleModal,
  downloadLink,
  onClick,
  showDelete,
}) => (
  <React.Fragment>
    <div className="filefdbcknpath">
      <a
        href={downloadLink}
        onClick={e => onClick(e)}
        className="file-wrp"
      >
        <span
          className="img-type pointer mdl_align"
        >
          {message ?
            <div
              className="progress-type progress-type_error three-dots"
              style={{ width: '100%' }}
              title={message}
            >{message}
            </div> :
            <div
              className={`three-dots progress-type ${upload && uploadingPc !== 100 && !type ? 'progress-type_upload' : `doctags ${flh.getFileExt(original)}-tag`}`}
              style={{ width: upload && !type ? `${uploadingPc}%` : '100%' }}
            >{upload && !type ? `${uploadingPc}%` : type}
            </div>}
        </span>
        <span className="file-name mdl_align">{original.length > filenameLen ? `${original.slice(0, filenameLen - 3)}...` : original}</span>
      </a>
      {showDelete && <span className="file-close mdl_align"><a href="#" onClick={e => onRemove(e, id)}>x</a></span>}
    </div>
    <ImageModal
      active={activeModal}
      toggleModal={toggleModal}
      file={file}
      upload={upload}
    />
  </React.Fragment>
);


AttachedFile.propTypes = {
  file: PropTypes.object.isRequired,
  toggleModal: PropTypes.func.isRequired,
  onRemove: PropTypes.func,
  activeModal: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default AttachedFile;



// WEBPACK FOOTER //
// ./src/components/files/attachedFile/AttachedFile.jsx